import React from 'react';
import HeroBanner from '../../components/landing/HeroBanner';
import SubCopySection from '../../components/landing/SubCopySection';
import SolutionsSection from '../../components/landing/SolutionsSection';
import ClientLogosSection from '../../components/landing/ClientLogosSection';
import TestimonialsSection from '../../components/landing/TestimonialsSection';
import ResourcesSection from '../../components/landing/ResourcesSection';
import { Grid } from '@mui/material';
import 'typeface-montserrat';
import { Location, useLocation, useOutletContext } from 'react-router-dom';

/**
 * Landing page view for logged out Syntiro site.
 */
const LandingPage = () => {
  const { handleDisplayLoginModal } = useOutletContext<{
    handleDisplayLoginModal: (display: boolean) => void;
  }>();
  const location: Location = useLocation();

  React.useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.hash]);

  return (
    <Grid container spacing={4} sx={{ m: -3 }}>
      <Grid size={12}>
        <HeroBanner handleDisplayLoginModal={handleDisplayLoginModal} />
      </Grid>
      <Grid size={12} sx={{ p: '0 !important', mt: -4 }}>
        <SubCopySection />
      </Grid>
      <Grid size={12}>
        <SolutionsSection />
      </Grid>
      <Grid size={12}>
        <ClientLogosSection />
      </Grid>
      <Grid size={12}>
        <TestimonialsSection />
      </Grid>
      <Grid size={12}>
        <ResourcesSection />
      </Grid>
    </Grid>
  );
};

export default LandingPage;
